import {
  fromDate,
  toCalendarDate,
  type CalendarDate,
} from "@internationalized/date";
import { use, type ContextType } from "react";

import { Passengers } from "~/components/passengers";
import { useTrack } from "~/lib/use-track";

import { TripContext } from "../_lib/trip-context";
import { Calendar } from "./calendar";

export type TripMutationParams =
  | {
      type: "UPDATE_DATE";
      calendarDate: CalendarDate;
    }
  | {
      type: "UPDATE_PASSENGERS";
      passengers: NonNullable<ContextType<typeof TripContext>>["passengers"];
    };

export function PassengersAndDates({
  isLoading,
  onChangeParams,
}: {
  isLoading: boolean;
  onChangeParams: (params: TripMutationParams) => void;
}) {
  const track = useTrack();
  const trip = use(TripContext);
  if (!trip) {
    throw new Error("TripContext is not available");
  }
  const { date, passengers, nights } = trip;
  const start = toCalendarDate(fromDate(date, "UTC"));
  return (
    <div className="mt-4 space-y-4">
      <Calendar
        date={start}
        range={nights + 1}
        onChange={(start) => {
          track({ name: "Change Trip Parameters", parameter: "date" });
          onChangeParams({
            type: "UPDATE_DATE",
            calendarDate: start,
          });
        }}
        isLoading={isLoading}
      />
      <fieldset className="grid grid-cols-[1fr_max-content] items-center gap-2">
        <Passengers
          value={passengers}
          onChange={({ adults, children }) => {
            track({ name: "Change Trip Parameters", parameter: "passengers" });
            onChangeParams({
              type: "UPDATE_PASSENGERS",
              passengers: { adults, children },
            });
          }}
        />
      </fieldset>
    </div>
  );
}
